import FooterSeoSection from "./components/FooterSeoSection";


const FooterSeo = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <FooterSeoSection />
      </div>
    </div>
  );
};

export default FooterSeo;
